export function sortForecastModels(models) {
  const premiumModels = [];
  const proModels = [];
  const freeModels = [];

  for (let model of models) {
    if (model.is_premium && !model.is_pro_only) premiumModels.push(model);
    else if (model.is_pro_only) proModels.push(model);
    else freeModels.push(model);
  }

  return [...premiumModels, ...proModels, ...freeModels];
}
